export const createCompanySelectionSearchHandlers = (setSearch) => {
    const handleSearchInputChange = ({ inputValue, action }) => {
        const actionType = action?.action;

        if (actionType === 'clear') {
            setSearch('');
            return;
        }

        if (actionType === 'input-change') {
            setSearch(inputValue ?? '');
        }
    };

    const handleSearchClear = (_value, action) => {
        if (action?.action === 'clear') {
            setSearch('');
        }
    };

    return { handleSearchInputChange, handleSearchClear };
};
